import { Link } from "react-router-dom";

const PriceCard = ({
  iconClass = "fas fa-chalkboard-teacher fa-2x",
  title = "Classroom Course",
  price = "$19.95",
  buttonText = "REGISTER NOW",
  buttonLink = "#",
  buttonProps = {},
  onClick,
  children,
}) => (
  <div className="col-lg-5 col-md-6 col-sm-10">
    <div
      className="h-100 p-3 rounded text-center"
      style={{ backgroundColor: "#252525" }}
    >
      <div className="mb-3">
        <i className={iconClass} style={{ color: "var(--metro-yellow)" }}></i>
      </div>
      <h3 className="h5 fw-bold mb-2 text-white">{title}</h3>
      <div className="mb-3">
        <span className="h3 fw-bold" style={{ color: "var(--metro-yellow)" }}>
          {price}
        </span>
      </div>
      {children}
      {onClick ? (
        <button
          onClick={onClick}
          className="btn btn-lg px-4 py-3 fw-bold text-dark metro-btn-primary text-decoration-none"
          style={{ backgroundColor: "var(--metro-yellow)", border: "none" }}
          {...buttonProps}
        >
          {buttonText}
        </button>
      ) : (
        <Link
          to={buttonLink}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-lg px-4 py-3 fw-bold text-dark metro-btn-primary text-decoration-none"
          style={{ backgroundColor: "var(--metro-yellow)", border: "none" }}
          {...buttonProps}
        >
          {buttonText}
        </Link>
      )}
    </div>
  </div>
);

export default PriceCard;
